import React from 'react';

function SubFormVacation({ formData, setFormData, mode = 'write' }) {
  // mode: 'write' | 'edit' | 'view'
  const isViewMode = mode === 'view';
  //const isWriteMode = mode === 'write';
  //const isEditMode = mode === 'edit';

  return (
    <table className="table table-bordered mt-3">
      <tbody>
        {/* 구분 */}
        <tr className="table-title">
          <td>구분</td>
          <td>
            {isViewMode ? (
              <span>
                {formData.category === 'annual'
                  ? '연월차 휴가'
                  : formData.category === 'half'
                  ? '반차'
                  : formData.category === 'event'
                  ? '경조휴가'
                  : ''}
              </span>
            ) : (
              <div className="d-flex gap-3">
                {['annual', 'half', 'event'].map((val) => (
                  <div className="form-check" key={val}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="category"
                      value={val}
                      checked={formData.category === val}
                      onChange={(e) =>
                        setFormData({ ...formData, category: e.target.value })
                      }
                    />
                    <label className="form-check-label">
                      {val === 'annual'
                        ? '연월차 휴가'
                        : val === 'half'
                        ? '반차'
                        : '경조휴가'}
                    </label>
                  </div>
                ))}
              </div>
            )}
          </td>
        </tr>

        {/* 기간 */}
        <tr className="table-title">
          <td>기간</td>
          <td>
            {isViewMode ? (
              <span>
                {formData.startDate} ~ {formData.endDate}
              </span>
            ) : (
              <div className="d-flex gap-3">
                <input
                  type="date"
                  className="form-control"
                  value={formData.startDate || ''}
                  onChange={(e) =>
                    setFormData({ ...formData, startDate: e.target.value })
                  }
                />
                <span className="align-self-center">~</span>
                <input
                  type="date"
                  className="form-control"
                  value={formData.endDate || ''}
                  onChange={(e) =>
                    setFormData({ ...formData, endDate: e.target.value })
                  }
                />
              </div>
            )}
          </td>
        </tr>

        {/* 사유 */}
        <tr className="table-title">
          <td>사유</td>
          <td>
            {isViewMode ? (
              <span>{formData.reason}</span>
            ) : (
              <input
                type="text"
                className="form-control"
                value={formData.reason || ''}
                onChange={(e) =>
                  setFormData({ ...formData, reason: e.target.value })
                }
              />
            )}
          </td>
        </tr>

        {/* 행선지 */}
        <tr className="table-title">
          <td>행선지</td>
          <td>
            {isViewMode ? (
              <span>{formData.destination}</span>
            ) : (
              <input
                type="text"
                className="form-control"
                value={formData.destination || ''}
                onChange={(e) =>
                  setFormData({ ...formData, destination: e.target.value })
                }
              />
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default SubFormVacation;